import { format, intervalToDuration } from "date-fns";

export const secondsToHms = (time: number) => {
  if (!time) {
    time = 0;
  };

  time = Math.round(time);
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time - hours * 3600) / 60);
  const seconds = Math.floor(time - hours * 3600 - minutes * 60);
  const formattedTime = new Date(0, 0, 0, hours, minutes, seconds);
  const timeFormat = hours >= 1 ? "hh:mm:ss" : "mm:ss";
  return format(formattedTime, timeFormat);
};

// 00:00:00
export const getColonFormatTime = (time: number): string => {
  time = Math.round(Number.isNaN(time) ? 0 : time);
  if (!time) return "00:00:00";

  const durationInterval = intervalToDuration({ start: 0, end: time * 1000 });
  const zeroPad = (num: number) => String(num).padStart(2, "0");
  return `${zeroPad(durationInterval.hours ?? 0)}:${zeroPad(durationInterval.minutes ?? 0)}:${zeroPad(durationInterval.seconds ?? 0)}`;
};

// 1 h 8 min 23 sec
export const getExtendedFormatTime = (time: number): string => {
  time = Math.round(Number.isNaN(time) ? 0 : time);
  if (!time) return "";

  const durationInterval = intervalToDuration({ start: 0, end: time * 1000 });
  let formatTime = "";
  if (durationInterval.hours) {
    formatTime += `${durationInterval.hours} h `;
  }
  if (durationInterval.minutes || durationInterval.hours) {
    formatTime += `${durationInterval.minutes} min `;
  }
  if (durationInterval.seconds) {
    formatTime += `${durationInterval.seconds} sec`;
  }
  return formatTime;
};

// 01h 08m 23s
export const getPaddedTimeFormat = (time: number): string => {
  time = Math.round(Number.isNaN(time) ? 0 : time);
  if (!time) return "";

  const durationInterval = intervalToDuration({ start: 0, end: time * 1000 });

  const hours = durationInterval.hours ? String(durationInterval.hours).padStart(2, "0") : "";
  const minutes = durationInterval.minutes ? String(durationInterval.minutes).padStart(2, "0") : "";
  const seconds = durationInterval.seconds ? String(durationInterval.seconds).padStart(2, "0") : "00";

  let formattedTime = "";
  if (hours) formattedTime += `${hours}h`;
  if (minutes || hours) formattedTime += ` ${minutes}m`;
  if (seconds || minutes || hours) formattedTime += ` ${seconds}s`;

  return formattedTime.trim();
};

export const getCommonDateTimeFormat = (date: Date | string | undefined): string | undefined => {
  if (!date) return undefined;
  const parsedDate = new Date(date);
  return format(parsedDate, "eee, d MMM 'at' hh:mma");
};

export const pdfFileName = (page: string) => {
  const date = new Date();
  const timezoneInteger = parseInt(format(date, "x"));
  let fileName = `SpoknAI ${page} ${format(date, "yyyy-MM-dd")} ${format(date, "HH")}h${format(date, "mm")}m${format(date, "ss")}s GMT`;
  if (timezoneInteger) {
    const timezone = format(date, "xxx").split(":");
    fileName += `${timezone[0]}h${timezone[1]}m`;
  }
  return fileName;
};

export const convertSelectedPropsToDates = <T>(
  obj: T,
  dateProps: (keyof T)[]
): T => {
  for (const key of dateProps) {
    obj[key] = new Date(obj[key] as any) as any;
  }

  return obj;
};

export const convertStringToDate = (dateString?: string, defaultValue: string = '2000-01-01T00:00:00Z'): Date => {
  return new Date(dateString || defaultValue);
};

export const formatLocalDateTime = (date: Date): string => {
  const padTwoDigits = (value: number): string => value.toString().padStart(2, "0");
  const padThreeDigits = (value: number): string => value.toString().padStart(3, "0");

  return `${date.getFullYear()}-${padTwoDigits(date.getMonth() + 1)}-${padTwoDigits(date.getDate())}T${padTwoDigits(date.getHours())}:${padTwoDigits(date.getMinutes())}:${padTwoDigits(date.getSeconds())}.${padThreeDigits(date.getMilliseconds())}`;
};
